import { AsyncState, onlyIf, async, nothing } from "widgets-for-react";
import { AdviceType } from "../../../../custom_api/bookarang/types"
import { CollectionPageProps } from "../../../pages/collection_page";
import { JumboProps } from "../../Kiosk/JumboKiosk";

interface BaseInspirationState {
  collectionPage: AsyncState<CollectionPageProps>
  isKioskMode: boolean
}

type ContentTexts = {
  [key: string]: {
    selectionPrompt: string;
    searchTitle: string;
    searchPlaceholder: string;
  };
};

export function CollectionPageLoaderWidget(props: BaseInspirationState) {
  return onlyIf(
    !props.isKioskMode,
    async<CollectionPageProps>(nothing, { key: 'collectionPageLoader' })(props.collectionPage)
      .map(resultUpdater => s0 => {
        const collectionPage = resultUpdater(s0.collectionPage);
        return ({ ...s0, collectionPage });
      }));
}

type KioskJumboCopy = { [key in AdviceType]: Pick<JumboProps, 'headerTitle' | 'contents'> }
export const jumboText: KioskJumboCopy = {
  mood: {
    headerTitle: 'Boekzoeker',
    contents: 'Inspiratie nodig voor een volgend boek?'
  },
  theme: {
    headerTitle: 'Boekzoeker',
    contents: 'Inspiratie nodig voor een volgend boek?'
  },
  book: {
    headerTitle: 'Boekzoeker',
    contents: 'Inspiratie nodig voor een volgend boek?'
  }
}

export const contentTexts: ContentTexts = {
  theme: {
    selectionPrompt: 'Vind boeken met een van deze populaire onderwerpen...',
    searchTitle: 'Of heb jij een ander onderwerp in gedachten?',
    searchPlaceholder: 'Onderwerp van boek'
  },
  book: {
    selectionPrompt: 'Vind boeken die lijken op een van deze actuele titels...',
    searchTitle: 'Of heb jij een ander boek in gedachten?',
    searchPlaceholder: 'Titel van boek'
  }
}
